
function trapFocus(element, elementToFocus = null) {
    const focusableElements = element.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    removeTrapFocus();

    window.trapFocusHandlers = {
        focusin: (event) => {
            if (
                event.target !== element &&
                event.target !== lastFocusableElement &&
                event.target !== firstFocusableElement
            )
                return;

            document.addEventListener('keydown', window.trapFocusHandlers.keydown);
        },
        focusout: function () {
            document.removeEventListener('keydown', window.trapFocusHandlers.keydown);
        },
        keydown: function (event) {
            if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key

            // On the last focusable element and tab forward, focus the first element.
            if (event.target === lastFocusableElement && !event.shiftKey) {
                event.preventDefault();
                firstFocusableElement.focus();
            }

            // On the first focusable element and tab backward, focus the last element.
            if (
                (event.target === element || event.target === firstFocusableElement) &&
                event.shiftKey
            ) {
                event.preventDefault();
                lastFocusableElement.focus();
            }
        },
    };

    element.addEventListener('focusout', window.trapFocusHandlers.focusout);
    element.addEventListener('focusin', window.trapFocusHandlers.focusin);

    (elementToFocus || firstFocusableElement).focus();
}

function removeTrapFocus(elementToFocus = null) {
    if (window.trapFocusHandlers) {
        document.removeEventListener('keydown', window.trapFocusHandlers.keydown);
    }

    if (elementToFocus) elementToFocus.focus();
}

class DetailsModal extends HTMLElement {
    constructor() {
        super();
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.content = this.querySelector('.modal__content');

        this.details.addEventListener(
            'toggle',
            (event) => {
                if (this.details.open) {
                    this.onOpen();
                } else {
                    this.onClose();
                }
            }
        );

        if (this.content) {
            this.content.addEventListener('keyup', (event) => {
                if (event.code.toUpperCase() === 'ESCAPE') this.close();
            });
        }

        this.summary.addEventListener('click', this.onSummaryClick.bind(this));
        this.querySelector('button[type="button"]').addEventListener(
            'click',
            this.close.bind(this)
        );
        this.summary.setAttribute('role', 'button');
    }

    isOpen() {
        return this.details.hasAttribute('open');
    }

    onSummaryClick(event) {
        event.preventDefault();
        event.target.closest('details').hasAttribute('open')
            ? this.close()
            : this.open(event);
    }

    onOpen() {
        document.body.addEventListener('click', this.onBodyClickEvent);
        document.body.classList.add('overflow-hidden');

        const trapFocusHandlers = trapFocus(
            this.details.querySelector('[tabindex="-1"]'),
            this.details.querySelector('input:not([type="hidden"])')
        );
        this.onFocusOutEvent = trapFocusHandlers.onFocusOut;
        this.onFocusInEvent = trapFocusHandlers.onFocusIn;

        this.details.addEventListener('focusout', this.onFocusOutEvent);
        this.details.addEventListener('focusin', this.onFocusInEvent);
    }

    onClose() {
        removeTrapFocus(this.summary);
        this.details.removeEventListener('focusout', this.onFocusOutEvent);
        this.details.removeEventListener('focusin', this.onFocusInEvent);
        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.body.classList.remove('overflow-hidden');
    }

    open(event) {
        this.onBodyClickEvent =
            this.onBodyClickEvent || this.onBodyClick.bind(this);
        this.details.setAttribute('open', true);
    }

    close(focusSummary = true) {
        removeTrapFocus(focusSummary ? this.summary : null);
        this.details.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.body.classList.remove('overflow-hidden');
    }

    onBodyClick(event) {
        if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
            this.close(false);
        }
    }
}

customElements.define('details-modal', DetailsModal);
